import {
  Maybe,
  ProductOfferCard,
  ProductOfferSingleCardTile,
  TileStatus,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { ProductOfferCardProps } from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import { getVXLColor } from 'shared/utils/getVXLColor/getVXLColor';

interface PromotionTilesNode extends VXLComponent {
  id: string;
  name:
    | VXLComponentId.PRODUCT_OFFER_CARD
    | VXLComponentId.PRODUCT_OFFER_CARD_NON_ACTIONABLE;
  props: ProductOfferCardProps;
}

export interface ExtendedProductOfferSingleCardTile
  extends Omit<ProductOfferSingleCardTile, 'card'> {
  productOfferCard?: ProductOfferCard | undefined;
}

const productOfferSingleCardTile = (
  tile: ExtendedProductOfferSingleCardTile,
  dependencies: HomeCardDependencies,
): Maybe<PromotionTilesNode> => {
  if (tile.status !== TileStatus.Loaded || !tile.productOfferCard) {
    return null;
  }
  const {
    titleText,
    bodyText,
    actionTextV2,
    onClickV2,
    illustrationKey,
    imageBackgroundColor,
  } = tile.productOfferCard;

  const { handleProductOfferCardActionResult } = dependencies;

  return {
    id: tile.id,
    name: onClickV2
      ? VXLComponentId.PRODUCT_OFFER_CARD
      : VXLComponentId.PRODUCT_OFFER_CARD_NON_ACTIONABLE,
    props: {
      titleText: titleText,
      bodyText: bodyText ?? '',
      buttonText: actionTextV2 ?? '',
      illustrationKey: illustrationKey as IllustrationKeyType,
      illustrationBackgroundColor: getVXLColor(imageBackgroundColor),
      onPress: () => {
        handleProductOfferCardActionResult(onClickV2!);
      },
    },
  };
};

export default productOfferSingleCardTile;
